// extracted by mini-css-extract-plugin
export default {"container":"Tabs_container__nohcy","tab":"Tabs_tab__hyw-t","active":"Tabs_active__HrZoE"};